import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { chinaContract, chinaContract12 } from "../../utils/contractHelpers";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../utils/Environment";

const PurchaseNFTwithWbtc = () => {
  const { account } = useWeb3React();
  const web3 = useWeb3();

  const contractType = Environment?.presale?.contractVersion;
  const isFirstContractVersion = contractType === "v0";

  const tokenAddress = Environment.presaleContract;

  const contract = isFirstContractVersion
    ? chinaContract(tokenAddress, web3)
    : chinaContract12(tokenAddress, web3);

  const WbtcAddress = Environment.wbtc;

  const purchaseNFTwithWbtc = useCallback(
    async (
      postApiRes,
      currentRound,
      nftPriceArray,
      price,
      nftPriceArray1,
      balance,
      index,
      checkBox,
    ) => {
      if (!account) throw new Error("WALLET_NOT_CONNECTED");

      // Convert WBTC value
      let amount = nftPriceArray1 / price;
      amount = parseFloat(amount).toFixed(6);
      const valueInWei = web3.utils.toWei(amount.toString(), "mwei");

      try {
        return new Promise(async (resolve, reject) => {
          const args = isFirstContractVersion
            ? [
                WbtcAddress,
                postApiRes.price,
                postApiRes.normalizationFactorToken,
                postApiRes.code,
                currentRound,
                nftPriceArray,
                postApiRes.deadline,
                index,
                postApiRes.agentsAddresses,
                postApiRes.agentsPercentages,
                postApiRes.v,
                postApiRes.r,
                postApiRes.s,
              ]
            : [
                WbtcAddress,
                postApiRes.price,
                postApiRes.normalizationFactorToken,
                postApiRes.normalizationFactorNft,
                postApiRes.code,
                currentRound,
                nftPriceArray,
                postApiRes.deadline,
                index,
                postApiRes.agentsAddresses,
                postApiRes.agentsPercentages,
                postApiRes.v,
                postApiRes.r,
                postApiRes.s,
              ];

          let gas;

          try {
            gas = await contract.methods.purchaseNFTWithToken
              .apply(contract.methods, args)
              .estimateGas({ from: account });
          } catch (err) {
            return reject(err);
          }

          const gasLimit = Math.floor(gas * 1.2);

          contract.methods.purchaseNFTWithToken
            .apply(contract.methods, args)
            .send({ from: account, gas: gasLimit })
            .on("transactionHash", (hash) => {
              console.log("NFT WBTC tx hash:", hash);
            })
            .on("receipt", (receipt) => {
              console.log("NFT WBTC purchase confirmed:", receipt);
              resolve({
                transactionHash: receipt?.transactionHash,
                receipt,
              });
            })
            .on("error", (error) => {
              console.error("NFT WBTC purchase error:", error);
              reject(error);
            });
        });
      } catch (error) {
        throw error;
      }
    },
    [account, contract, web3, isFirstContractVersion],
  );

  return { purchaseNFTwithWbtc };
};

export default PurchaseNFTwithWbtc;
